import { Spinner } from '@chakra-ui/react';
import { useToast } from '@morressier/alembic';
import { useNavigate } from 'react-router-dom';

import { useCreateWorkspaceRole } from 'src/api/mutations';
import { useWorkspace } from '../../SubmissionContexts/Users/userHook';
import { RoleForm } from './RoleForm';
import { IRolePayload } from './roleFormSchema';

const CreateRole = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const {
    workspaceId,
    isLoadingWorkspace,
    workspaceShortname: shortname
  } = useWorkspace();

  const createRoleMutation = useCreateWorkspaceRole(workspaceId);

  const rolesPath = `/app/workspace/${shortname}/manage/roles`;

  const handleSubmit = async ({
    name,
    displayName,
    permissions
  }: IRolePayload) => {
    const res = await createRoleMutation.mutateAsync({
      name: name?.trim(),
      displayName,
      permissions
    });

    if (res.isSuccess) {
      toast({
        variant: 'success',
        title: 'Role Created',
        isClosable: true
      });

      navigate(rolesPath);
    } else {
      toast({
        variant: 'error',
        title: res.message,
        isClosable: true
      });
    }
  };

  if (isLoadingWorkspace) return <Spinner />;
  if (!workspaceId) return <div>Workspace not found</div>;

  return (
    <RoleForm
      workspaceId={workspaceId}
      title="Create Role"
      submitLabel="Create Role"
      defaultValues={{
        name: '',
        displayName: '',
        permissions: {},
        permissionsGroup: {}
      }}
      onSubmit={handleSubmit}
      onCancel={() => navigate(rolesPath)}
    />
  );
};

export default CreateRole;
